<template>
    <breadCrumbs title="User Cards" main="Users" title1="User Cards" />

    <div class="container-fluid user-card">
        <div class="row">
            <div class="col-lg-4 col-md-6 box-col-4" v-for="(item, index) in menu" :key="index">
                <div class="card custom-card">
                    <div class="card-header"><img class="img-fluid" :src="getImgUrl(item.img)" alt=""></div>
                    <div class="card-profile"><img class="rounded-circle" :src="getImgUrl(item.img1)" alt=""></div>
                    <ul class="card-social">
                        <li><a href="https://www.facebook.com" target="_blank"><i class="fa fa-facebook"></i></a></li>
                        <li><a href="https://www.google.com" target="_blank"><i class="fa fa-google-plus"></i></a></li>
                        <li><a href="https://www.twitter.com" target="_blank"><i class="fa fa-twitter"></i></a></li>
                        <li><a href="https://www.instagram.com" target="_blank"><i class="fa fa-instagram"></i></a></li>
                        <li><a href="https://www.rss.com" target="_blank"><i class="fa fa-rss"></i></a></li>
                    </ul>
                    <div class="text-center profile-details">
                        <router-link to="/users/profile">
                            <h2>{{ item.name }}</h2>
                        </router-link>
                        <h6>{{ item.title }}</h6>
                    </div>
                    <div class="card-footer row">
                        <div class="col-4 col-sm-4">
                            <h6>Follower</h6>
                            <h3 class="counter">{{ item.follower }}</h3>
                        </div>
                        <div class="col-4 col-sm-4">
                            <h6>Following</h6>
                            <h3><span class="counter">{{ item.following }}</span>K</h3>
                        </div>
                        <div class="col-4 col-sm-4">
                            <h6>Total Post</h6>
                            <h3><span class="counter">{{ item.total }}</span>M</h3>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import data from '../../../data/usercard.json'
export default {
    name: 'userCards',
    data() {
        return {
            menu: data.data
        }
    },
    methods: {
        getImgUrl(path) {
            return require('../../../assets/images/' + path)
        }
    },

}
</script>
